import React from "react";
import Button from "@material-ui/core/Button";
import { useHistory } from "react-router-dom";
import AvatarIcon from "../resources/AvatarIcon";
import { MiniLogo } from "../components/MiniLogo";
import { useTermsAndConditionsStyles } from "../themes/termsAndConditionsStyles";
import { Translate, withLocalize } from "react-localize-redux";

const ProAppTermsAndConditionsPage: React.FC = () => {
  const classes = useTermsAndConditionsStyles();
  const history = useHistory();
  const bProLink = "https://bpro.bwt.com/welcome";

  return (
    <Translate>
      {({ translate }) => (
        <div className={classes.pageContainer}>
          <div className={classes.topBar}>
            <Button
              classes={{ root: classes.buttonRoot }}
              onClick={() => {
                history.push("/");
              }}
            >
              <AvatarIcon color="var(--col-navy-500)" />
            </Button>
            <MiniLogo />
          </div>

          <div className={classes.titleContainer}>
            <div id="proAppTermsAndConditions.titleLine1">
              {translate("proAppTermsAndConditions.titleLine1")}
            </div>
            <div id="proAppTermsAndConditions.titleLine2">
              {translate("proAppTermsAndConditions.titleLine2")}
            </div>
            <div id="proAppTermsAndConditions.titleLine3">
              {translate("proAppTermsAndConditions.titleLine3")}
            </div>
            <div id="proAppTermsAndConditions.bwt">
              {translate("proAppTermsAndConditions.bwt")}
            </div>
          </div>

          <div className={classes.bodyContainer}>
            <div
              id="proAppTermsAndConditions.paragraph1"
              className={classes.paragraph}
            >
              {translate(
                "proAppTermsAndConditions.paragraph1",
                { bProLink },
                { renderInnerHtml: true }
              )}
            </div>

            <div
              id="proAppTermsAndConditions.paragraph2"
              className={classes.paragraph}
            >
              {translate("proAppTermsAndConditions.paragraph2")}
            </div>

            <div className={classes.subTitle}>
              <b id="proAppTermsAndConditions.subTitle1">
                {translate("proAppTermsAndConditions.subTitle1")}
              </b>
            </div>

            <div
              id="proAppTermsAndConditions.userAccount"
              className={classes.paragraph}
            >
              {translate(
                "proAppTermsAndConditions.userAccount",
                {},
                { renderInnerHtml: true }
              )}
            </div>
            <div
              id="proAppTermsAndConditions.1Part2"
              className={classes.paragraph}
            >
              {translate("proAppTermsAndConditions.1Part2")}
            </div>
            <div
              id="proAppTermsAndConditions.1Part3"
              className={classes.paragraph}
            >
              {translate("proAppTermsAndConditions.1Part3")}
            </div>
            <div
              id="proAppTermsAndConditions.1Part4"
              className={classes.paragraph}
            >
              {translate("proAppTermsAndConditions.1Part4")}
            </div>
            <div
              id="proAppTermsAndConditions.1Part5"
              className={classes.paragraph}
            >
              {translate("proAppTermsAndConditions.1Part5")}
            </div>
            <div
              id="proAppTermsAndConditions.1Part6"
              className={classes.paragraph}
            >
              {translate("proAppTermsAndConditions.1Part6")}
            </div>
            <div
              id="proAppTermsAndConditions.1Part7"
              className={classes.paragraph}
            >
              {translate("proAppTermsAndConditions.1Part7")}
            </div>

            <div
              id="proAppTermsAndConditions.intellectualPropertyRights"
              className={classes.paragraph}
            >
              {translate(
                "proAppTermsAndConditions.intellectualPropertyRights",
                {},
                { renderInnerHtml: true }
              )}
            </div>

            <div
              id="proAppTermsAndConditions.contents"
              className={classes.paragraph}
            >
              {translate(
                "proAppTermsAndConditions.contents",
                {},
                { renderInnerHtml: true }
              )}
            </div>

            <div
              id="proAppTermsAndConditions.productDescription"
              className={classes.paragraph}
            >
              {translate(
                "proAppTermsAndConditions.productDescription",
                {},
                { renderInnerHtml: true }
              )}
            </div>

            <div
              id="proAppTermsAndConditions.userData"
              className={classes.paragraph}
            >
              {translate(
                "proAppTermsAndConditions.userData",
                {},
                { renderInnerHtml: true }
              )}
            </div>

            <div
              id="proAppTermsAndConditions.electronicCommunication"
              className={classes.paragraph}
            >
              {translate(
                "proAppTermsAndConditions.electronicCommunication",
                {},
                { renderInnerHtml: true }
              )}
            </div>

            <div className={classes.subTitle}>
              <b id="proAppTermsAndConditions.subTitle2">
                {translate("proAppTermsAndConditions.subTitle2")}
              </b>
            </div>

            <div className={classes.list}>
              <b id="proAppTermsAndConditions.1">
                {translate("proAppTermsAndConditions.1")}
              </b>
              <div id="proAppTermsAndConditions.1Point1">
                {translate("proAppTermsAndConditions.1Point1")}
              </div>
              <div id="proAppTermsAndConditions.1Point2">
                {translate("proAppTermsAndConditions.1Point2")}
              </div>
              <div id="proAppTermsAndConditions.1Point3">
                {translate(
                  "proAppTermsAndConditions.1Point3",
                  { bProLink },
                  { renderInnerHtml: true }
                )}
              </div>
            </div>

            <div className={classes.list}>
              <b id="proAppTermsAndConditions.2">
                {translate("proAppTermsAndConditions.2")}
              </b>
              <div id="proAppTermsAndConditions.2Point1">
                {translate("proAppTermsAndConditions.2Point1")}
              </div>
              <div id="proAppTermsAndConditions.2Point2">
                {translate("proAppTermsAndConditions.2Point2")}
              </div>
              <div id="proAppTermsAndConditions.2Point3">
                {translate("proAppTermsAndConditions.2Point3")}
              </div>
            </div>

            <div className={classes.list}>
              <b id="proAppTermsAndConditions.3">
                {translate("proAppTermsAndConditions.3")}
              </b>
              <div id="proAppTermsAndConditions.3Point1">
                {translate("proAppTermsAndConditions.3Point1")}
              </div>
            </div>

            <div className={classes.list}>
              <b id="proAppTermsAndConditions.4">
                {translate("proAppTermsAndConditions.4")}
              </b>
              <div id="proAppTermsAndConditions.4Point1">
                {translate("proAppTermsAndConditions.4Point1")}
              </div>
            </div>

            <div className={classes.list}>
              <b id="proAppTermsAndConditions.5">
                {translate("proAppTermsAndConditions.5")}
              </b>
              <div id="proAppTermsAndConditions.5Point1">
                {translate("proAppTermsAndConditions.5Point1")}
              </div>
            </div>

            <div className={classes.list}>
              <b id="proAppTermsAndConditions.6">
                {translate("proAppTermsAndConditions.6")}
              </b>
              <div id="proAppTermsAndConditions.6Point1">
                {translate("proAppTermsAndConditions.6Point1")}
              </div>
            </div>

            <div className={classes.list}>
              <b id="proAppTermsAndConditions.7">
                {translate("proAppTermsAndConditions.7")}
              </b>
              <div id="proAppTermsAndConditions.7Point1">
                {translate("proAppTermsAndConditions.7Point1")}
              </div>
              <div id="proAppTermsAndConditions.7Point2">
                {translate("proAppTermsAndConditions.7Point2")}
              </div>
            </div>

            <div className={classes.list}>
              <b id="proAppTermsAndConditions.8">
                {translate("proAppTermsAndConditions.8")}
              </b>
              <div id="proAppTermsAndConditions.8Point1">
                {translate("proAppTermsAndConditions.8Point1")}
              </div>
              <div>
                <div id="proAppTermsAndConditions.8Point1Part2">
                  {translate("proAppTermsAndConditions.8Point1Part2")}
                </div>
                <div id="proAppTermsAndConditions.8Point1Part3">
                  {translate("proAppTermsAndConditions.8Point1Part3")}
                </div>
                <div id="proAppTermsAndConditions.8Point1Part4">
                  {translate("proAppTermsAndConditions.8Point1Part4")}
                </div>
                <div id="proAppTermsAndConditions.8Point1Part5">
                  {translate("proAppTermsAndConditions.8Point1Part5")}
                </div>
                <div id="proAppTermsAndConditions.8Point1Part6">
                  {translate("proAppTermsAndConditions.8Point1Part6")}
                </div>
              </div>
              <div id="proAppTermsAndConditions.8Point2">
                {translate("proAppTermsAndConditions.8Point2")}
              </div>
            </div>

            <div className={classes.list}>
              <b id="proAppTermsAndConditions.9">
                {translate("proAppTermsAndConditions.9")}
              </b>
              <div id="proAppTermsAndConditions.9Point1">
                {translate("proAppTermsAndConditions.9Point1")}
              </div>
              <div id="proAppTermsAndConditions.9Point2">
                {translate("proAppTermsAndConditions.9Point2")}
              </div>
              <div id="proAppTermsAndConditions.9Point3">
                {translate("proAppTermsAndConditions.9Point3")}
              </div>
              <div>
                <div id="proAppTermsAndConditions.bwt">
                  {translate("proAppTermsAndConditions.bwt")}
                </div>
                <div id="proAppTermsAndConditions.addressLine1">
                  {translate("proAppTermsAndConditions.addressLine1")}
                </div>
                <div id="proAppTermsAndConditions.addressLine2">
                  {translate("proAppTermsAndConditions.addressLine2")}
                </div>
                <div id="proAppTermsAndConditions.addressLine3">
                  {translate("proAppTermsAndConditions.addressLine3")}
                </div>
                <div id="proAppTermsAndConditions.email">
                  {translate("proAppTermsAndConditions.email")}
                </div>
              </div>
            </div>

            <div className={classes.list}>
              <b id="proAppTermsAndConditions.10">
                {translate("proAppTermsAndConditions.10")}
              </b>
              <div id="proAppTermsAndConditions.10Point1">
                {translate("proAppTermsAndConditions.10Point1")}
              </div>
              <div id="proAppTermsAndConditions.10Point2">
                {translate("proAppTermsAndConditions.10Point2")}
              </div>
              <div id="proAppTermsAndConditions.10Point3">
                {translate("proAppTermsAndConditions.10Point3")}
              </div>
              <div id="proAppTermsAndConditions.10Point4">
                {translate("proAppTermsAndConditions.10Point4")}
              </div>
              <div id="proAppTermsAndConditions.10Point4Paragraph">
                {translate("proAppTermsAndConditions.10Point4Paragraph")}
              </div>
              <div id="proAppTermsAndConditions.10Point5">
                {translate("proAppTermsAndConditions.10Point5")}
              </div>
              <div id="proAppTermsAndConditions.10Point5Paragraph">
                {translate("proAppTermsAndConditions.10Point5Paragraph")}
              </div>
            </div>

            <div className={classes.list}>
              <b id="proAppTermsAndConditions.11">
                {translate("proAppTermsAndConditions.11")}
              </b>
              <div id="proAppTermsAndConditions.11Paragraph1">
                {translate("proAppTermsAndConditions.11Paragraph1")}
              </div>
            </div>

            <div className={classes.list}>
              <b id="proAppTermsAndConditions.12">
                {translate("proAppTermsAndConditions.12")}
              </b>
              <div id="proAppTermsAndConditions.12Paragraph1">
                {translate("proAppTermsAndConditions.12Paragraph1")}
              </div>
            </div>

            <div className={classes.list}>
              <b id="proAppTermsAndConditions.13">
                {translate("proAppTermsAndConditions.13")}
              </b>
              <div id="proAppTermsAndConditions.13Paragraph1">
                {translate("proAppTermsAndConditions.13Paragraph1")}
              </div>
            </div>

            <div className={classes.list}>
              <b id="proAppTermsAndConditions.14">
                {translate("proAppTermsAndConditions.14")}
              </b>
              <div id="proAppTermsAndConditions.14Paragraph1">
                {translate("proAppTermsAndConditions.14Paragraph1")}
              </div>

              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  gridTemplateRows: "repeat(6, 1fr)",
                  gridAutoFlow: "column",
                  columnGap: "8px",
                }}
              >
                <div>
                  <b id="proAppTermsAndConditions.bwt">
                    {translate("proAppTermsAndConditions.bwt")}
                  </b>
                </div>
                <div id="proAppTermsAndConditions.addressLine1">
                  {translate("proAppTermsAndConditions.addressLine1")}
                </div>
                <div id="proAppTermsAndConditions.addressLine2">
                  {translate("proAppTermsAndConditions.addressLine2")}
                </div>
                <div id="proAppTermsAndConditions.addressLine3">
                  {translate("proAppTermsAndConditions.addressLine3")}
                </div>
                <div id="proAppTermsAndConditions.email">
                  {translate("proAppTermsAndConditions.email")}
                </div>
                <div>T.: +43 6232 50110</div>
                <div
                  id="proAppTermsAndConditions.companyRegisterNumber"
                  style={{ gridRow: "2" }}
                >
                  {translate("proAppTermsAndConditions.companyRegisterNumber", {
                    companyNumber: "FN 96162 s",
                  })}
                </div>
                <div id="proAppTermsAndConditions.commercialRegisterCourt">
                  {translate(
                    "proAppTermsAndConditions.commercialRegisterCourt",
                    { commercialRegisterCourt: "Landesgericht Wels" }
                  )}
                </div>
                <div id="proAppTermsAndConditions.uidNumber">
                  {translate("proAppTermsAndConditions.uidNumber", {
                    uidNumber: "ATU23473603",
                  })}
                </div>
                <div id="proAppTermsAndConditions.regulatoryAuthority">
                  {translate("proAppTermsAndConditions.regulatoryAuthority", {
                    regulatoryAuthority: "BH Vöcklabruck",
                  })}
                </div>
                <div id="proAppTermsAndConditions.austrianEconomic">
                  {translate("proAppTermsAndConditions.austrianEconomic")}
                </div>
              </div>
            </div>

            <div className={classes.list}>
              <b id="proAppTermsAndConditions.15">
                {translate("proAppTermsAndConditions.15")}
              </b>
              <div id="proAppTermsAndConditions.15Point1">
                {translate("proAppTermsAndConditions.15Point1")}
              </div>
              <div id="proAppTermsAndConditions.15Point2">
                {translate("proAppTermsAndConditions.15Point2")}
              </div>
            </div>
          </div>
        </div>
      )}
    </Translate>
  );
};

export default withLocalize(ProAppTermsAndConditionsPage);
